import {
  errorMessage,
  hireflixAutoRefillRoute,
  applicationsCountsKey,
  employerApplicationsKey,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

type UseHireflixPlanAutoRefillProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useHireflixPlanAutoRefill = ({
  setErrorText,
  onSuccess,
}: UseHireflixPlanAutoRefillProps) => {
  const client = useQueryClient();

  const {
    mutate: hireflixPlanAutoRefill,
    isLoading: isHireflixPlanAutoRefillLoading,
  } = useMutation({
    mutationFn: (variables: { auto_refill: boolean }) =>
      axiosInstance
        .post(hireflixAutoRefillRoute, variables)
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status === 200) {
        // ✅ Refresh relevant cached data
        client.invalidateQueries(employerApplicationsKey);
        client.invalidateQueries(applicationsCountsKey);
        client.invalidateQueries([profileKey]);

        onSuccess?.();
        setErrorText('');
      } else {
        setErrorText(data?.message || errorMessage);
      }
    },
    onError: (error: { message?: string }) => {
      setErrorText(error?.message || errorMessage);
    },
  });

  return {
    hireflixPlanAutoRefill,
    isHireflixPlanAutoRefillLoading,
  };
};
